export const member = 'member';
export const employee = 'employee';
export const memberUser = 'member_user';
export const serviceAccountUser = 'service_account_user';
export const investmentAdvisor = 'investment_advisor';
export const indirectMemberUser = 'indirect_member_user';
export const firmAdmin = 'firm_admin';
